import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

import { addIcons } from 'ionicons';
import {
	arrowForwardOutline,
	documentOutline,
	documentTextOutline,
	folderOutline,
	imageOutline,
	listOutline,
	mailOutline,
	openOutline,
	personCircleOutline,
	star,
	starOutline,
} from 'ionicons/icons';

addIcons({
	'arrow-forward-outline': arrowForwardOutline,
	'mail-outline': mailOutline,
	'folder-outline': folderOutline,
	'list-outline': listOutline,
	'person-circle-outline': personCircleOutline,
	'star': star,
	'star-outline': starOutline,
	'open-outline': openOutline,
	'document-outline': documentOutline,
	'document-text-outline': documentTextOutline,
	'image-outline': imageOutline,
});

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
